// extracted by mini-css-extract-plugin
export default {"pageCenter":"pageLoading_pageCenter__sRFqB","loader":"pageLoading_loader__6N6po","spin988":"pageLoading_spin988__f3G8i","circle":"pageLoading_circle__fP3wQ"};